module.exports = __webpack_public_path__ + "img/logo.7aa8703c.png";